import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

export const useIsTokenExpired = (): boolean => {
  const [isExpired, setIsExpired] = useState<boolean>(false);
  useEffect(() => {
    let cancelled = false;

    const checkTokenExpiration = async () => {
      try {
        const session = await fetchAuthSession();
        const exp = session.tokens?.idToken?.payload?.exp;
        const currentTime = Date.now() / 1000; // to get in seconds

        if (cancelled) return;

        if (!exp) {
          setIsExpired(true);
          return;
        }

        setIsExpired(exp < currentTime);
      } catch {
        if (cancelled) return;
        setIsExpired(true);
      }
    };

    void checkTokenExpiration();

    return () => {
      cancelled = true;
    };
  }, []);

  return isExpired;
};
